































































import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import AmataList from '@/components/AmataList.vue'
import AmataListItem from '@/components/AmataListItem.vue'
import Badge from '@/components/Badge.vue'
import { versionCompare } from '@/utils/helpers'
import { MenuItem } from '@/store/modules/MypageMenu'

export default Vue.extend({
  name: 'Mypage',
  components: {
    AmataList,
    AmataListItem,
    Badge
  },
  computed: {
    ...mapGetters('Auth', ['token']),
    ...mapGetters('AppInfo', ['appVersion']),
    ...mapGetters('MyData', ['myName', 'myPoint', 'myProfileImageURL', 'isInReviewProfileImage']),

    menuItems(): MenuItem[] {
      return [
        {
          title: 'お知らせ',
          icon: 'info-standard',
          link: '/notice/syslog',
          hasBadge: this.$store.getters['Notice/hasNoticeBadge']
        },
        {
          title: 'アカウント設定',
          isHeader: true
        },
        {
          title: '通話待ち設定',
          icon: 'phone-handset',
          link: '/call/waiting/setting'
        },
        {
          title: 'プロフィール編集',
          icon: 'user',
          link: '/profile/edit'
        },
        {
          title: 'お気に入り',
          icon: 'heart',
          link: '/favlist'
        },
        {
          title: 'ブロックリスト',
          icon: 'ban',
          link: '/blocklist'
        },
        {
          title: 'アカウント引き継ぎ',
          icon: 'mobile',
          link: '/account/handover'
        },
        {
          title: 'マイメニュー',
          isHeader: true
        },
        {
          title: '通話ログ',
          icon: 'history',
          link: '/call/log'
        },
        {
          title: '通知設定',
          icon: 'bell',
          link: '/notification/setting'
        },
        ...this.$store.getters['MypageMenu/menus'],
        {
          title: 'アプリについて',
          isHeader: true
        },
        {
          title: '使い方',
          icon: 'file',
          link: this.$store.getters.FRONT_URL + '/intro.html'
        },
        {
          title: 'よくある質問',
          icon: 'file',
          link: this.$store.getters.FRONT_URL + '/faq.html'
        },
        {
          title: '利用規約',
          icon: 'file',
          link: this.$store.getters.FRONT_URL + '/kiyaku.html'
        },
        {
          title: '特定商取引に基づく表記',
          icon: 'file',
          link: this.$store.getters.FRONT_URL + '/tokusyo.html'
        },
        {
          title: 'プライバシーポリシー',
          icon: 'lock',
          link: this.$store.getters.FRONT_URL + '/policy.html'
        },
        {
          title: 'お問い合わせ',
          icon: 'email',
          link: '/ask'
        },
        {
          title: '退会',
          icon: 'window-close',
          link: '/taikai'
        }
      ]
    },

    webVersion(): string {
      return this.$store.getters['AppInfo/webVersion']
    }
  },
  created() {
    this.fetchData({
      page: 'get_init'
    })
    this.getMyMenu()
    this.renewToken()
  },
  methods: {
    ...mapMutations('Auth', ['setToken']),
    ...mapMutations('MypageMenu', ['setMenus']),

    /**
     * サーバからデータを取得
     */
    fetchData(this: any, params: any): Promise<any> {
      return this.$store.dispatch('MyData/getMyProfile')
    },

    /**
     * マイメニューの取得
     */
    async getMyMenu(this: any) {
      const res = await this.$http.post('/mymenu/', { page: 'get_init ' })
      if (res.data.error) {
        console.error(res.data.error)
        return
      }

      if (res.data && res.data.menus) {
        const menus = Object.values(res.data.menus)
        const myMenus = []
        for (let i = 0; i < menus.length; i++) {
          myMenus.push({
            title: menus[i]['title'],
            icon: menus[i]['icon'],
            link: menus[i]['link']
          })
        }
        this.setMenus(myMenus)
      }
    },

    /**
     * マイメニューを開く
     */
    openMyMenu(this: any, url: string) {
      // Android 4.4.4 以下なら通常のブラウザで開く
      const target =
        this.$_platformIsAndroid && !versionCompare(device.version, '4.4.4') ? '_system' : '_blank'
      this.$_open(url, target)
    },

    /**
     * token の更新
     */
    renewToken(this: any): Promise<any> {
      return new Promise(async resolve => {
        const res = await this.$http.get('/token_renew/')
        if (res.data.new_token) {
          this.setToken(res.data.new_token)
        }
        resolve(res.data)
      })
    },

    /**
     * 無料ポイントページをオープン
     */
    openFreePoint(this: any) {
      const app = this.$_hasCordova ? 1 : 0
      const url = `${this.FRONT_URL}/web/web_index.html#/point/free/${app}/${this.token}`
      this.$_open(url)
    },

    /**
     * キャッシュのクリア
     */
    async clearCaches() {
      const message = '端末に保存されているキャッシュを削除します。よろしいですか？'
      const buttonIndex = await this.$_confirm(message, '', ['キャンセル', '削除'])
      if (!this.$_clickedConfirmOK(buttonIndex)) {
        return
      }
      this.$_resetStoreState(/(Auth|MyData)/)

      if (this.$_hasCordova) {
        this.$_clearCache()
          .then(() => {
            location.reload()
          })
          .catch(err => {
            console.error(err)
          })
      } else {
        location.reload()
      }
    }
  }
})
